<template>
  <div class="page__shopee-marketing a-page">
    <div style="background-color:white; padding:10px; border-radius: 4px; overflow: hidden">
      <el-row style="margin-bottom: 10px">
        <el-col :sm="12" style="display: flex; gap: 20px">
          <shop-select v-model="shopee_shop.selected" :shopee_shop_list="shopee_shop.list"></shop-select>
        </el-col>
      </el-row>

      <div style="margin-top: 50px">
        <div style="display: flex">
          <div style="flex: 1; display: flex; gap: 10px">
            <div style="width: 250px; max-width: 250px">
              <el-date-picker
                class="full-w" v-model="date_range" type="daterange" range-separator="-"
                :start-placeholder="$t('base.start_time')" :end-placeholder="$t('base.end_time')" size="mini"
                format="dd-MM-yyyy"
                :clearable="false" :picker-options="picker_options"
                @change="m__get_data()">
              </el-date-picker>
            </div>
            <div style="width: 200px; max-width: 200px">
              <el-select size="mini" value="" class="full-w" v-model="transaction_status">
                <el-option value="all" label="Tất cả trạng thái"></el-option>
                <el-option value="success" label="Đã thanh toán"></el-option>
                <el-option value="pending" label="Chưa thanh toán"></el-option>
              </el-select>
            </div>
            <div style="width: 200px; max-width: 200px">
              <el-input v-model="search_keyword" :placeholder="$t('input.placeholder')" size="mini"></el-input>
            </div>
            <div v-if="false" style="width: 200px; max-width: 200px">
              <el-button type="primary" size="mini" icon="el-icon-search" :loading="loading.get_data"
                         @click="m__get_data()">
                {{ $t('base.lookup') }}
              </el-button>
            </div>
          </div>
        </div>
      </div>

      <div style="margin-top: 40px">
        <div style="display: flex; gap: 15px;" class="hide-scroll">
          <div
            style="width: 226px; border: 1px solid #e5e5e5; border-radius: 6px; min-width: 180px; padding: 16px; cursor: pointer">
            <div style="font-size: 14px; color: #333; height: 40px">
              Tổng số chiến dịch đã chạy
            </div>
            <div style="margin-top: 5px; color: #333; font-size: 22px;">
              {{ c__overview.total_campaign }}
            </div>
          </div>
          <div
            style="width: 226px; border: 1px solid #e5e5e5; border-radius: 6px; min-width: 180px; padding: 16px; cursor: pointer">
            <div style="font-size: 14px; color: #333; height: 40px">
              GMV đạt được
            </div>
            <div style="margin-top: 5px; color: #333; font-size: 22px;">
              {{ m__calculate(c__overview.total_gmv) | currency }}
            </div>
          </div>
          <div
            style="width: 226px; border: 1px solid #e5e5e5; border-radius: 6px; min-width: 180px; padding: 16px; cursor: pointer">
            <div style="font-size: 14px; color: #333; height: 40px">
              ROAS đạt được
            </div>
            <div style="margin-top: 5px; color: #333; font-size: 22px;">
              {{ c__overview.total_roas | currency }}
            </div>
          </div>
          <div
            style="width: 226px; border: 1px solid #e5e5e5; border-radius: 6px; min-width: 180px; padding: 16px; cursor: pointer">
            <div style="font-size: 14px; color: #333; height: 40px">
              Phí vận hành đã thanh toán
            </div>
            <div style="margin-top: 5px; color: #333; font-size: 22px;">
              {{ m__calculate(c__overview.total_paid) | currency }}
            </div>
          </div>
          <div
            style="width: 226px; border: 1px solid #e5e5e5; border-radius: 6px; min-width: 180px; padding: 16px; cursor: pointer">
            <div style="font-size: 14px; color: #333; height: 40px">
              Phí vận hành chưa thanh toán
            </div>
            <div style="margin-top: 5px; color: #333; font-size: 22px;">
              {{ m__calculate(c__overview.total_unpaid) | currency }}
            </div>
          </div>
        </div>
      </div>

      <div style="margin-top: 30px">
        <el-table :data="c__show_filter_data">
          <el-table-column label="Campaign ID" width="120px">
            <template slot-scope="scope">
              {{ scope.row.campaign_id }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.timestamp')" width="120px">
            <template slot-scope="scope">
              {{ scope.row.created_time | moment('DD-MM-YYYY') }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.config')" show-tooltip-when-overflow width="120px">
            <template slot-scope="scope">
              {{ scope.row.config_name || '-' }}
              <br>
              {{ $t('base.note') }}: {{ scope.row.note || '-' }}
            </template>
          </el-table-column>
          <el-table-column v-if="false" :label="'Mục tiêu'" width="120px">
            <template slot-scope="scope">
              ROAS: {{ scope.row.target_roas || '-' }}
              <br>
              GMV: {{ scope.row.target_gmv || '-' }}
            </template>
          </el-table-column>
          <el-table-column v-if="false" :label="'Kết quả đạt được'" width="120px">
            <template slot-scope="scope">
            </template>
          </el-table-column>
          <el-table-column :label="'Lượt xem'" width="120px">
            <template slot-scope="scope">
              {{ scope.row.metrics.impression | format_currency }}
            </template>
          </el-table-column>
          <el-table-column :label="'Lượt click'" width="120px">
            <template slot-scope="scope">
              {{ scope.row.metrics.click | format_currency }}
            </template>
          </el-table-column>
          <el-table-column :label="'Tỉ lệ click'" width="120px">
            <template slot-scope="scope">
              {{ scope.row.metrics.ctr || 0 }}%
            </template>
          </el-table-column>
          <el-table-column :label="'Doanh thu'" width="120px">
            <template slot-scope="scope">
              {{ m__calculate(scope.row.metrics.broad_gmv) | format_currency }}
            </template>
          </el-table-column>
          <el-table-column :label="'Chi phí'" width="120px">
            <template slot-scope="scope">
              {{ m__calculate(scope.row.metrics.cost) | format_currency }}
            </template>
          </el-table-column>
          <el-table-column :label="'CIR'" width="120px">
            <template slot-scope="scope">
              {{ scope.row.metrics.broad_cir || 0 }}%
            </template>
          </el-table-column>
          <el-table-column :label="'ROAS'" width="120px">
            <template slot-scope="scope">
              {{ scope.row.metrics.broad_roi.toFixed(1) || 0 }}
            </template>
          </el-table-column>
          <el-table-column :label="'Phí vận hành'" width="120px">
            <template slot-scope="scope">
              {{ m__calculate(scope.row.cost) | format_currency }}
            </template>
          </el-table-column>
          <el-table-column :label="'Trạng thái'" width="150px">
            <template slot-scope="scope">
              <template v-if="scope.row.cost === 0">
                <strong class="text-success">Không tính phí</strong>
              </template>
              <template v-else>
                <strong v-if="scope.row.transaction_status === 'success'" class="text-success">Đã thanh toán</strong>
                <strong v-if="scope.row.transaction_status === 'pending'" class="text-danger">Chưa thanh toán</strong>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import {uniqBy as _uniqBy, sumBy as _sumBy} from "lodash";
import {picker_options} from "../../../addon/options";
import {get_shop_mixins} from "../../../mixins/get_shop";
import {fix_ads_mixins} from "../../../mixins/fix_ads";

export default {
  mixins: [get_shop_mixins, fix_ads_mixins],

  data() {
    return {
      date_range: [this.dayjs().subtract(3, 'month').toDate(), new Date()],
      picker_options: picker_options,
      search_keyword: '',
      transaction_status: 'all',
      loading: {
        get_data: false
      },
      data: []
    }
  },

  async beforeMount() {
    await this.m__get_shopee_shop()
  },

  watch: {
    'shopee_shop.selected': function () {
      this.shop = this.shopee_shop.list.find(i => i._id === this.shopee_shop.selected)
      this.m__get_data()
    }
  },

  computed: {
    c__show_filter_data() {
      let result = this.data

      if (this.transaction_status !== 'all') {
        result = result.filter(item => item.transaction_status === this.transaction_status)
      }

      const words = this.remove_unicode(this.search_keyword)
      result = result.filter(item => this.remove_unicode(JSON.stringify({
        campaign_id: item.campaign_id
      }).normalize()).includes(words))

      return result
    },

    c__overview() {
      const total_campaign = _uniqBy(this.data, 'campaign_id').length
      const total_gmv = _sumBy(this.data, 'metrics.broad_gmv')
      const total_cost = _sumBy(this.data, 'metrics.cost')
      const total_roas = total_cost ? total_gmv / total_cost : 0
      const total_paid = _sumBy(this.data.filter(item => item.transaction_status === 'success'), 'cost')
      const total_unpaid = _sumBy(this.data.filter(item => item.transaction_status === 'pending'), 'cost')
      return {
        total_campaign,
        total_gmv,
        total_cost,
        total_roas,
        total_paid,
        total_unpaid
      }
    },
  },

  methods: {
    async m__get_data() {
      this.loading.get_data = true
      try {
        const start_time = this.dayjs(this.date_range[0]).unix()
        const end_time = this.dayjs(this.date_range[1]).unix()

        const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/atosa_agent/daily_report', {
          shop_id: this.shop.shop_id,
          start_time,
          end_time
        }, this.cf())
        this.data = response.body.data
      } catch (e) {
        console.error(e)
      } finally {
        this.loading.get_data = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/pas/log/auto_by_ai.vue